import { GlobalStatus, StockStatus, TransactionType } from "@gtpl/shared-models/common-models";
import { StoreConsumptionStatus } from "@gtpl/shared-models/procurement-management";
import { ApiProperty } from "@nestjs/swagger";

export class StoreIssuesRequest {
    @ApiProperty()
    storeConsumptionId: number;
    @ApiProperty()
    indentDate: Date;
    @ApiProperty()
    indentNo: string;
    @ApiProperty()
    storeConsumptionCode: string;
    @ApiProperty()
    consumedDate: Date;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    salePerson: number;
    @ApiProperty()
    status: StoreConsumptionStatus;
    @ApiProperty()
    isPreparedMaterial: GlobalStatus;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    issuedQuantity: number;
    @ApiProperty()
    returnedQuantity: number;
    @ApiProperty()
    barcode: string;
    @ApiProperty()
    productName: string;
    @ApiProperty()
    stockType: StockStatus;
    @ApiProperty()
    transactionType: TransactionType;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    tracebilityCodeId: number;
    @ApiProperty()
    poNumber: string;
    @ApiProperty()
    soItemName: string;
    @ApiProperty()
    itemName: string;
    @ApiProperty()
    issueType?: string;
    @ApiProperty()
    locationsInfo?:any[];
    @ApiProperty()
    issuedTo: number;
    @ApiProperty()
    departmentId: number
}